<div id="self-tour-base-container" class="prospect-grid-container">
  <div id="self-tour-base-container-top" class="text-3xl sm:font-rhetorik-sans sm:text-40px">
    Self-Tour Registration
  </div>
  <div id="self-tour-step-container" class="w-full sm:w-3/4 mb-12 mt-4">
    <div class="self-tour-circle" [ngClass]="{'self-tour-circle-selected': stepNumber >= 1 }"><div *ngIf="stepNumber <= 1">1</div><div *ngIf="stepNumber > 1"><mat-icon>check</mat-icon></div></div>
    <div class="self-tour-dash"><hr></div>
    <div class="self-tour-circle" [ngClass]="{'self-tour-circle-selected': stepNumber >= 2 }"><div *ngIf="stepNumber <= 2">2</div><div *ngIf="stepNumber > 2"><mat-icon>check</mat-icon></div></div>
    <div class="self-tour-dash"><hr></div>
    <div class="self-tour-circle" [ngClass]="{'self-tour-circle-selected': stepNumber >= 3 }"><div *ngIf="stepNumber <= 3">3</div><div *ngIf="stepNumber > 3"><mat-icon>check</mat-icon></div></div>
    <div class="self-tour-dash"><hr></div>
    <div class="self-tour-circle" [ngClass]="{'self-tour-circle-selected': stepNumber >= 4 }"><div *ngIf="stepNumber <= 4">4</div><div *ngIf="stepNumber > 4"><mat-icon>check</mat-icon></div></div>
    <div class="self-tour-dash"><hr></div>
    <div class="self-tour-circle" [ngClass]="{'self-tour-circle-selected': stepNumber >= 5 }"><div *ngIf="stepNumber <= 5">5</div><div *ngIf="stepNumber > 5"><mat-icon>check</mat-icon></div></div>
  </div>
  <p id="self-tour-base-atext" *ngIf="additionalText !== null">{{additionalText}}</p>
  <div><router-outlet></router-outlet></div>
</div>
